import styled from "styled-components";

export const Dropdown = styled.div`
  margin-top: 5px;
`;

export const ControlSelector = styled.select`
  width: 200px;
`;
